module.exports = __webpack_public_path__ + "static/media/burger.59b8dc66.gif";